<template>
  <div class="calendar-component">
    <a v-b-toggle :href="`#calendar-${index}`" @click.prevent>
      <span>{{ $t("forms.showCalendar") }}</span>
      <span>{{ $t("forms.hideCalendar") }}</span>
    </a>
    <b-collapse :id="`calendar-${index}`">
      <div class="calendar">
        <h5>
          {{ getMonthName() }} {{ year }}
          <div class="calendar-navigation">
            <bootstrap-icon @click="getMonth(-1)" icon="chevron-left" />
            <bootstrap-icon @click="getMonth(1)" icon="chevron-right" />
          </div>
        </h5>
        <div class="month">
          <div class="days">
            <div class="day" v-for="(day, index) of days" :key="index">
              <div
                class="day-name"
                :class="{
                  diff:
                    day.price !== mealPlan.price ||
                    day.discountedPrice !== mealPlan.discountedPrice,
                }"
              >
                {{ getDayName(day.date) }}
              </div>
              <div class="inputs">
                <input
                  :class="{ diff: day.price !== mealPlan.price }"
                  type="number"
                  v-model="day.price"
                  @change="overrideChange(day)"
                />
                <input
                  :class="{
                    diff: day.discountedPrice !== mealPlan.discountedPrice,
                  }"
                  type="number"
                  v-model="day.discountedPrice"
                  @change="overrideChange(day)"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <b-button @click="saveCalendar" variant="gray" class="my-2">{{
        $t("forms.save")
      }}</b-button>
    </b-collapse>
  </div>
</template>

<script>
import { BCollapse, BButton } from "bootstrap-vue-3";
import Toast from "@/components/Toast.vue";
import { useToast } from "vue-toastification";
import moment from "moment";
import { v4 as uuidv4 } from "uuid";

export default {
  components: {
    BCollapse,
    BButton,
  },
  props: {
    mealPlan: { type: Object, required: true },
  },
  watch: {
    mealPlan: {
      handler() {
        this.getDaysInMonth();
      },
      deep: true
    }
  },
  data() {
    let date = new Date();
    date = new Date(date.getFullYear(), date.getMonth(), 1);
    date = new Date(
      date.getTime() + Math.abs(date.getTimezoneOffset() * 60000)
    );
    return {
      year: date.getFullYear(),
      month: date.getMonth(),
      days: [],
      index: uuidv4(),
      overrides: [],
    };
  },
  created() {
    this.getDaysInMonth();
  },
  methods: {
    getDaysInMonth() {
      let date = new Date(this.year, this.month, 1);
      date = new Date(
        date.getTime() + Math.abs(date.getTimezoneOffset() * 60000)
      );
      var days = [];
      while (date.getMonth() === this.month) {
        const d = {
          date: new Date(date.getTime()),
          price: this.mealPlan.price,
          discountedPrice: this.mealPlan.discountedPrice,
        };

        // ak je v overrides then override
        const index = this.mealPlan.priceOverrides.findIndex((o) =>
          this.dateMatch(d.date, new Date(o.date))
        );
        if (index !== -1) {
          d.price = this.mealPlan.priceOverrides[index].price;
          d.discountedPrice = this.mealPlan.priceOverrides[index].discountedPrice;
        }
        days.push(d);
        date.setDate(date.getDate() + 1);
      }
      this.days = days;
    },
    getMonthName() {
      return moment.months(this.month);
    },
    getDayName(date) {
      return moment(date).format("dd") + " " + moment(date).format("DD");
    },
    getMonth(offset) {
      let newDate = new Date(this.year, this.month + offset, 1);
      newDate = new Date(newDate.getFullYear(), newDate.getMonth(), 1);
      newDate = new Date(
        newDate.getTime() + Math.abs(newDate.getTimezoneOffset() * 60000)
      );
      this.year = newDate.getFullYear();
      this.month = newDate.getMonth();
      this.getDaysInMonth();
    },
    overrideChange(day) {
      const index = this.overrides.findIndex((o) => o.date === day.date);
      if (index !== -1) {
        this.overrides[index] = day;
      } else {
        this.overrides.push(day);
      }
    },
    dateMatch(d1, d2) {
      return d1.getFullYear() === d2.getFullYear() &&
        d1.getMonth() === d2.getMonth() &&
        d1.getDate() === d2.getDate();
    },
    saveCalendar() {
      const body = {
        priceOverrides: this.overrides,
      };
      body.priceOverrides.forEach((po) => {
        (po.price = po.price.toString()),
          (po.discountedPrice = po.discountedPrice.toString());
      });
      this.$MealPlans
        .updateResourceByUrl({ url: this.mealPlan["@id"], body })
        .then((response) => {
          if (response.status === 200) {
            const toast = useToast();
            this.$helper.showToast(
              toast,
              Toast,
              this.$t("messages.mealPlanUpdated"),
              "",
              "success"
            );
          }
        })
        .catch((error) => {
          if (error.response) {
            const toast = useToast();
            this.$helper.showToast(
              toast,
              Toast,
              error.response.data["hydra:title"],
              error.response.data["hydra:description"],
              "danger"
            );
          }
        });
    },
  },
};
</script>
